<template>
  <!-- needed ref="thead" to eliminate the vuesax error -->
  <tbody ref="thead">
    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in rows">
      <vs-td>{{ tr.id }}</vs-td>
      <vs-td>{{ tr.firstName }} {{ tr.lastName }}</vs-td>
      <vs-td>{{ tr.companyName }}</vs-td>
      <vs-td>{{ tr.email }}</vs-td>
      <vs-td>{{ tr.mobile }}</vs-td>
      <vs-td><span v-if="tr.stats">{{ tr.stats.dateLastLoggedIn | longDate }}</span></vs-td>
      <vs-td><span v-if="tr.stats">{{ tr.stats.dateLastCheckedIn | longDate }}</span></vs-td>
      <vs-td><span v-if="tr.stats">{{ tr.stats.visitCount }}</span></vs-td>
      <vs-td><span v-if="tr.stats">{{ tr.stats.hostCount }}</span></vs-td>
      <vs-td><span v-if="tr.stats">{{ tr.stats.locationCount }}</span></vs-td>
      <vs-td>
        <vs-chip :color="getOrderStatusColor(tr.status)">
          {{ tr.status }}</vs-chip>
      </vs-td>
      <vs-td>{{ tr.entity.dateCreated | fullDate }}</vs-td>
      <vs-td class="whitespace-no-wrap">
        <router-link :to="{ name: 'edit-tenant', params: { id: tr.id } }">
          <feather-icon
            icon="EditIcon"
            svgClasses="w-5 h-5 hover:text-primary stroke-current"
          />
        </router-link>
      </vs-td>
    </vs-tr>
  </tbody>
</template>

<script>
export default {
  props: ['rows'],
  methods: {
    clicktr (tr) {
      this.$router.push(`/tenants/${tr.id}`)
    }, // needed to eliminate the error this.$parent.clicktr
    dblclicktr (tr) {
    } // needed to eliminate the error this.$parent.dblclicktr
  }
}
</script>
